import axios from 'axios';

// Signed file URLs expire; durable offline images need Cache Storage / IndexedDB (see file module), not SecureLS alone.

const getDefaultState = () => {
    return {
        treasureChestAssets: []
    }
};

const state = getDefaultState();

const getters = {
    getTreasureChestAssets: state => state.treasureChestAssets
}

const actions = {

    async getTreasureChestForUser({commit, state, rootState}) {
        if (!navigator.onLine && state.treasureChestAssets.length > 0) {
            console.log('Offline: Using cached treasure chest assets');
            return state.treasureChestAssets;
        }

        const fetchFromApi = async () => {
            axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payload = {};

            const response = await axios.post(`/v2/treasure-chest/get-treasure-chest-for-user`, payload, config);

            const treasureChestAssets = response.data.treasureChestAssets;
            commit('SET_TREASURE_CHEST_ASSETS', treasureChestAssets);

            return treasureChestAssets;
        };

        const hasBearer = !!rootState.auth?.bearer;
        const hasCachedList = state.treasureChestAssets.length > 0;

        if (navigator.onLine && hasCachedList && hasBearer) {
            fetchFromApi().catch((err) => {
                if (!navigator.onLine && state.treasureChestAssets.length > 0) {
                    console.log('Offline during treasure chest refresh, keeping cache');
                    return;
                }
                console.error('Background refresh treasure chest failed:', err);
            });
            return state.treasureChestAssets;
        }

        try {
            return await fetchFromApi();
        }
        catch (err) {
            if (!navigator.onLine && state.treasureChestAssets.length > 0) {
                console.log('Offline: Fetch failed, using cached treasure chest assets');
                return state.treasureChestAssets;
            }
            console.error('getTreasureChestForUser failed:', err);
        }

    },

    // A followed participant's treasure chest (journey Observers only), not stored: it's not the current user's chest
    async getParticipantTreasureChest({ rootState }, { journeyID, participantID }) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        const config = {
            headers: {
                Authorization: rootState.auth.bearer
            },
        };

        const response = await axios.post(`/v2/journey/get-participant-treasure-chest`, {
            JourneyID: journeyID,
            ParticipantID: participantID,
        }, config);

        return response.data.treasureChestAssets || [];
    },

    // async update({commit, dispatch, rootState}, payload) {
    //
    //     axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
    //
    //     try {
    //
    //         let config = {
    //             headers: {
    //                 Authorization: rootState.auth.bearer
    //             },
    //         };
    //
    //         let payloadAPI = {
    //             Assets: payload.Assets,
    //         };
    //
    //         if (payload.hasOwnProperty('JourneyID')) {
    //             payloadAPI.JourneyID = payload.JourneyID;
    //         }
    //         else {
    //             if (payload.hasOwnProperty('UsersIDs')) {
    //                 payloadAPI.UsersIDs = payload.UsersIDs;
    //             }
    //         }
    //
    //         await axios.post(`/treasure-chest/update`, payloadAPI, config);
    //
    //     }
    //     catch (err) {
    //         throw new Error(err);
    //     }
    // },


    resetState({ commit }) {
        commit('RESET_STATE');
    },
}

const mutations = {

    SET_TREASURE_CHEST_ASSETS(state, treasureChestAssets) {
        state.treasureChestAssets = treasureChestAssets;
    },

    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
